var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2884 12.0568C15.8215 12.0634 15.4378 12.4472 15.4312 12.914C15.4246 13.3808 15.7977 13.7539 16.2645 13.7473L23.787 13.6414L12.3203 25.1081C11.9855 25.4428 11.978 25.978 12.3034 26.3034C12.6289 26.6289 13.164 26.6213 13.4988 26.2866L24.9652 14.8201L24.8593 22.3421C24.8527 22.8089 25.2258 23.182 25.6926 23.1754C26.1594 23.1688 26.5432 22.7851 26.5498 22.3183L26.6842 12.7764C26.6928 12.5531 26.6135 12.3293 26.4456 12.1613C26.3466 12.0623 26.2282 11.9941 26.1019 11.9566C26.0945 11.9544 26.0869 11.9522 26.0794 11.9502C26.0069 11.9308 25.9304 11.921 25.8511 11.9221L16.2884 12.0568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.c891f08916dbbc6dc119615c0cd20c9e.svg";
export { ForwardRef as ReactComponent };